var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal-fade" } }, [
    _vm.isVisible
      ? _c(
          "div",
          {
            staticClass: "modal-backdrop",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.close.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-card",
                attrs: {
                  role: "dialog",
                  "aria-modal": "true",
                  "aria-labelledby": "modal-title",
                },
              },
              [
                _c("header", { staticClass: "modal-card-header" }, [
                  _c("div", { staticClass: "header-icon" }, [
                    _c("img", {
                      attrs: {
                        alt: "Project estimator icon",
                        src: "img/project-estimator-logo-positive.svg",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "header-text" }, [
                    _c(
                      "h2",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "modal-title" },
                      },
                      [_vm._v("Marketing Preferences")]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-card-body" }, [
                  _c("p", { staticClass: "intro-text" }, [
                    _vm._v(
                      "\n          Choose how you'd like to hear from us. We'd love to keep you updated with the latest offers, news, and updates.\n          You can change these at any time.\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "preference-list" }, [
                    _c(
                      "label",
                      {
                        staticClass: "preference-item",
                        class: { "is-checked": _vm.preferences.email },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "preference-icon email-icon" },
                          [_c("fa", { attrs: { icon: "envelope" } })],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "preference-info" }, [
                          _c("span", { staticClass: "preference-label" }, [
                            _vm._v("Email"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "preference-desc" }, [
                            _vm._v(
                              "Receive newsletters, promotions, and account updates"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "preference-control" },
                          [
                            _c("b-checkbox", {
                              model: {
                                value: _vm.preferences.email,
                                callback: function ($$v) {
                                  _vm.$set(_vm.preferences, "email", $$v)
                                },
                                expression: "preferences.email",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "preference-item",
                        class: { "is-checked": _vm.preferences.sms },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "preference-icon sms-icon" },
                          [_c("fa", { attrs: { icon: "comment-dots" } })],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "preference-info" }, [
                          _c("span", { staticClass: "preference-label" }, [
                            _vm._v("SMS"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "preference-desc" }, [
                            _vm._v(
                              "Get text alerts for time-sensitive offers and reminders"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "preference-control" },
                          [
                            _c("b-checkbox", {
                              model: {
                                value: _vm.preferences.sms,
                                callback: function ($$v) {
                                  _vm.$set(_vm.preferences, "sms", $$v)
                                },
                                expression: "preferences.sms",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "essential-note" }, [
                    _vm._v(
                      "\n          You'll still receive essential service emails, such as account and security updates, regardless of your preferences above.\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("footer", { staticClass: "modal-card-footer" }, [
                  _c(
                    "button",
                    { staticClass: "btn-secondary", on: { click: _vm.close } },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    { staticClass: "btn-primary", on: { click: _vm.save } },
                    [_vm._v("Save Preferences")]
                  ),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }